import { getBRCurrencyFormat } from '@app/utils/formmater';
import React, { Ref } from 'react';
import NumberFormat, { NumberFormatProps, NumberFormatValues } from 'react-number-format';

type Props = NumberFormatProps & {
  value: number | null;
  onNumberValueChange: (value: number | null) => void;
};

function CurrencyInput({ onNumberValueChange, value, ...props }: Props, ref?: Ref<HTMLInputElement>) {
  function handleValueChange(values: NumberFormatValues) {
    const { floatValue } = values;
    if (floatValue) {
      const changeValueAsNumber = floatValue / 100;
      onNumberValueChange(changeValueAsNumber);
    } else {
      onNumberValueChange(null);
    }
  }

  return (
    <NumberFormat
      getInputRef={ref}
      value={value ? value * 100 : ''}
      onValueChange={handleValueChange}
      decimalScale={2}
      decimalSeparator=","
      thousandSeparator="."
      thousandsGroupStyle="thousand"
      allowNegative={false}
      {...props}
      format={format}
    />
  );
}

function format(value: any) {
  if (!Number(value)) return '';
  return getBRCurrencyFormat(value / 100);
}

export default React.forwardRef(CurrencyInput);
